import { render, staticRenderFns } from "./TemplatesGallery.vue?vue&type=template&id=97480666&scoped=true"
import script from "./TemplatesGallery.vue?vue&type=script&lang=js"
export * from "./TemplatesGallery.vue?vue&type=script&lang=js"
import style0 from "./TemplatesGallery.vue?vue&type=style&index=0&id=97480666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97480666",
  null
  
)

export default component.exports